// operational_status is plain text from Zerity, so there is no enum to infer. These are the values
// seen in production; Zerity can add one without warning.
export const OPERATIONAL_STATUSES = [
  "Active",
  "Available",
  "Defleeting",
  "Insurance Repair",
  "Insurance Write Off",
  "Repair Off-site (bodyshop)",
  "Repair Off-site (mechanical)",
  "Repair On-site",
  "Returned",
] as const

export type OperationalStatus = (typeof OPERATIONAL_STATUSES)[number]

export const USABLE_OPERATIONAL_STATUSES: OperationalStatus[] = ["Active", "Available"]
